import { useSelector } from 'react-redux';
import { getCurrentlyStagedFlowByFlowId } from 'automation-ui-canvas/selectors/flowSelectors';
import WorkflowNameWithDescription from 'automation-ui-management/components/WorkflowNameWithDescription';
import UIEditorToolbar from 'UIComponents/nav/UIEditorToolbar';
import { jsx as _jsx } from "react/jsx-runtime";
const AiAssistantGenerateFlowHeader = ({
  flowId
}) => {
  const currentlyStagedFlow = useSelector(getCurrentlyStagedFlowByFlowId(flowId));
  return /*#__PURE__*/_jsx(UIEditorToolbar, {
    titleText: /*#__PURE__*/_jsx(WorkflowNameWithDescription, {
      use: "on-dark",
      flow: currentlyStagedFlow ? currentlyStagedFlow.toHybridFlowInterface() : undefined,
      flowId: flowId,
      readOnly: true
    })
  });
};
export default AiAssistantGenerateFlowHeader;